import React, { Fragment } from "react";
import "../../styles/common.css";
import "../../styles/auth.css";
import {Link, Outlet } from "react-router-dom";
import logo from "../../assets/images/logo.svg";


const Layout = () => {

  return (
    <Fragment>
      <div className="auth-root" >
      <div className="auth ">
        <section className="main">

          <div className="logo">
            <img src={logo} alt="Roam" />
          </div>
         
            <Outlet />


           
        </section>
        <div className="footer fd-row g-16">
            <Link className="fs-10 color-white" to="/login">Terms of Use</Link>
            <div className="divider"><svg xmlns="http://www.w3.org/2000/svg" width="2" height="25" viewBox="0 0 2 25" fill="none">
  <path d="M1 0.870117C1 19.1275 1 23.8107 1 23.8701" stroke="#292929" stroke-linecap="square"/>
</svg></div>
            <Link className="fs-10 color-white" to="/login">Privacy Policy</Link>
          </div>
         
      </div>
      </div>
    </Fragment>
  );
};

export default Layout;
